<template>
  <div>
    <div v-if="!EmptyObject(news)" class="card-wrap">
      <div class="row">
        <div class="col-sm-12 col-md-3 my-3 pl-sm-5 pl-md-0">
          <div class="image-wrapper">
            <img class="image" :src="news.image_url" />
          </div>
        </div>
        <div class="col-sm-12 col-md-9 my-3 pl-sm-5 pl-md-4">
          <div style="flex-direction:row;display:flex;justify-content:flex-start">
            <div class="left">
              <div style="font-size: 2.2rem; line-height: 0.75">
                {{ getDate(new Date(news.post_timestamp).getDate()) }}
              </div>
              <div style="font-size: 1.2rem; margin-top: 0.5rem">
                {{ getMonth(new Date(news.post_timestamp).getMonth()) }}
              </div>
            </div>
            <div class="right">
              <div class="hd">{{ news.news_title }}</div>
              <div class="hds">
                <span :key="ind" v-for="(tag, ind) in news.news_tags">
                  {{ tag
                  }}<span v-if="ind < news.news_tags.length - 1">, </span>
                </span>
                <span>.</span>
              </div>
            </div>
          </div>
          <div class="dsc">{{ news.news_desc }}</div>
          <div
            :key="change"
            class="row justify-content-between"
            style="margin-top: 2rem !important; width: 100%"
          >
            <button @click="openLinkInTab(news.news_link)" class="btn btn-next">
              Read More
            </button>
            <div style="display: flex; flex-direction: row">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div
                    class="bubbleButton"
                    v-on="on"
                    @click="copyToClipboard(restLink)"
                  >
                    <CustomIcon name="link" size="1.7" genericColor />
                  </div>
                </template>
                <span>{{ restLink }}</span>
              </v-tooltip>
              <span
                style="margin-left: 1rem"
                @click="shareViaFacebook(fbLink)"
                class="bubbleButton"
                ><v-icon style="color: var(--button-color)"
                  >mdi-facebook</v-icon
                ></span
              >
              <template v-if="!pinButton">
              <span
                v-if="!pin"
                @click="pinThisNews"
                style="margin-left: 1rem"
                class="bubbleButton"
                :key="change"
                ><CustomIcon name="not-saved" size="1.7" genericColor
              /></span>
              <span
                v-else
                @click="unPinThisNews"
                style="margin-left: 1rem"
                class="bubbleButton"
                :key="change"
                ><CustomIcon name="nav-saved-jobs" size="1.7" genericColor
              /></span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
      <div style="text-align: center; width: 100%">
        <span style="padding-right: 1rem">
            <!-- <v-icon color="#fff">{{ snackIcon }}</v-icon> -->
        </span>Copied to clipboard
      </div>
    </v-snackbar>
    <div id="copy">
    </div>
  </div>
</template>

<script>
import { IsEmptyObject } from "../../../globalFunctions";
import CustomIcon from "../../global-components/customIcon";
import { getUrl } from "../../../globalConstants";
import { PIN_NEWS } from "../../../Api/candidate_api";
export default {
  name: "news-single-view",
  components: {
    CustomIcon,
  },
  props: {
    newsObj: Object,
    pinned: Boolean,
    hidesave:false,
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      news: {},
      EmptyObject: IsEmptyObject,
      fbLink: "",
      restLink: "",
      isPinned: false,
      change: 0,
      prev: false,
      timeOut: 1000,
      snackbar: false,
      bgColor: "#454545",
      pin:false,
      key:0,
      pinButton:false
    };
  },
  methods: {
    getMonth(ind) {
      const self = this;
      return self.$constants.MONTHS[ind].substring(0, 3).toUpperCase();
    },
    getDate(ind) {
      if (parseInt(ind) > 9) return ind;
      else return "0" + ind;
    },
    openLinkInTab(link) {
      window.open(link, "_blank");
    },
    shareViaFacebook(link) {
      if (!this.prev)
        FB.ui(
          {
            method: "share",
            href: link,
          },
          function (response) {}
        );
    },
    copyToClipboard(url) {
      if (!this.prev) {
        const el = document.createElement("textarea");
        el.value = url;
        document.getElementById('copy').appendChild(el);
        el.select();
        document.execCommand("copy");
       document.getElementById('copy').removeChild(el);
        this.snackbar=true
      }
      // self.snackbar = true;
      // self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
      // self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
      // self.snackMessage = "Copied to clipboard";
    },
    unPinThisNews() {
      const self = this;
      if (!this.prev) {
        let data = {
          lookup_id: self.news.lookup_id,
          action: "pin",
          undo: true,
        };
        PIN_NEWS(data)
          .then(function () {
            self.pin = false;
            self.change++;
          })
          .catch();
      }
    },
    pinThisNews() {
      const self = this;
      if (!this.prev) {
        let data = {
          lookup_id: self.news.lookup_id,
          action: "pin",
        };
        PIN_NEWS(data)
          .then(function () {
            self.pin = true;
            self.change++;
          })
          .catch();
      }
    },
  },
  mounted() {
    const self = this;
    self.pinButton=self.hidesave
    if (this.preview) this.prev = this.preview;
    if (!self.EmptyObject(self.newsObj)) {
      self.news = self.newsObj;
     
      if(!!self.pinned)self.pin=true;
      else self.pin=self.newsObj.pin
      self.fbLink =
        getUrl() + "/news/" + self.news.lookup_id + "&source=facebook";
      self.restLink =
        getUrl() + "/news/" + self.news.lookup_id + "&source=rest";
    }
    
  },
};
</script>

<style scoped>
.card-wrap {
  background-color: white;
  padding: 2.5rem 0;
  border-bottom: 0.1rem solid #e4e4e4;
}
.image-wrapper {
 
}
.image {
  width: 100%;
  height:20rem;
  object-fit: cover;
}
.left {
  text-align: left;
  background-color: #f2f3f8;
  padding:8px 15px;
  color: #166bff;
  margin-right: 0.5rem;
  max-height: 5.5rem;
}
.right {
  text-align: left;
  margin-left: 1rem;
}
.hd {
  font-size: 1.6rem;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #166bff;
  margin-bottom:1.5rem ;
}
.hds {
  font-size: 1.3rem;
  line-height: 1.54;
  text-align: left;
  color: #8f8f8f;
}
.dsc {
  font-size: 14px;
  line-height: 1.57;
  text-align: left;
  color: #666666;
  margin-top: 2rem;
}
</style>